/** Foxline branch_name per PG store (matches stiqos-api STORE_BRANCH_MAP). */
export const STORE_BRANCH_MAP = {
  "PG-ATH-SKOUFA": "Υποκ/μα Σκουφά & Ομήρου 58",
  "PG Skoufa": "Υποκ/μα Σκουφά & Ομήρου 58",
  "PG-ATH-OMIROU": "Υποκ/μα Ομήρου 40",
  "PG Omirou": "Υποκ/μα Ομήρου 40",
  "PG-ATH-PANORMOU": "Υποκ/μα Πανόρμου 117 PG",
  "PG Panormou": "Υποκ/μα Πανόρμου 117 PG",
  "PG-ATH-KOLOKOTRONI": "Υποκ/μα Κολοκοτρώνη 33",
  "PG Kolokotroni": "Υποκ/μα Κολοκοτρώνη 33",
  "PG-ATH-TSAMADOU": "Υποκ/μα Τσαμαδού",
  "PG Tsamadou": "Υποκ/μα Τσαμαδού",
  "PG-ATH-HEIDEN": "Υποκ/μα Χέυδεν 8",
  "PG Heiden": "Υποκ/μα Χέυδεν 8",
  "PG-ATH-DOUSMANI": "Υποκ/μα Δούσμανη 24 (PG)",
  "PG Dousmani": "Υποκ/μα Δούσμανη 24 (PG)",
  "PG-ATH-DRAKOU": "Υποκ/μα Δράκου 3-5",
  "PG Drakou": "Υποκ/μα Δράκου 3-5",
  "PG-PAP-KINGS": "PG-PAP-KINGS",
};

/** Foxline branch_name per DN store (leave resolution; prefer emp.store when set). */
export const DN_STORE_BRANCH_MAP = {
  "DN-ATH-AKADIMIAS": "Υποκ/μα Ακαδημίας 56",
  "DN Akadimias": "Υποκ/μα Ακαδημίας 56",
  "DN-ATH-PANORMOU": "Υποκ/μα Πανόρμου 117 DN",
  "DN Panormou": "Υποκ/μα Πανόρμου 117 DN",
  "DN-ATH-DRAKOU": "Υποκ/μα Δράκου 3-5",
  "DN Drakou": "Υποκ/μα Δράκου 3-5",
};

/** Extra Foxline branch strings → leave store (shared branches need emp.store first). */
export const LEAVE_BRANCH_ALIASES = Object.freeze({
  "Υποκ/μα Πανόρμου 117": "DN-ATH-PANORMOU",
  "Υποκ/μα Πανόρμου 117 DN": "DN-ATH-PANORMOU",
  "Υποκ/μα Ακαδημίας 56": "DN-ATH-AKADIMIAS",
});
